import { connect } from 'react-redux';
import { setLinkState } from 'core/slices/link';
import Link from '../../../components/link/Link';

export default connect(state => ({}), {
  setLinkState
})(Link);